<template>
  <div class="regist-exam">
    <v-base-card>
      <template v-slot:heading>
        <div class="result-heading">
          <p class="result-heading__text mr-4">テスト作成</p>
          <p class="result-heading__text">テスト名登録</p>
        </div>
      </template>

      <template v-slot:content>
        <v-section-panel useBreak>
          <template v-slot:content>
            <v-container class="py-0" fluid>
              <v-row>
                <v-col :cols="stepCols" class="py-0" v-resize="setStepCols">
                  <v-stepp :stepps="stepps" disabled/>
                </v-col>
              </v-row>
            </v-container>
            <v-container fluid>
              <v-row>
                <v-col cols=6>
                  <v-result-table/>
                </v-col>
                <v-col cols=6 class="pa-0">
                  <v-bar-charts/>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-section-panel>

        <!-- 学年選択 -->
        <v-section-panel useBreak v-if="$store.getters.selectedSubjectHasChild && !$store.getters['sheet/isPresetMode'] ">
          <template v-slot:title> 学年を選択してください。</template>
          <template v-slot:content>
            <v-choice-grades
              :selected="selectedGradeId"
              @onChange="changeGrade"
            />
          </template>
        </v-section-panel>

          <!-- テスト名入力 -->
          <v-section-panel useBreak>
            <template v-slot:title>
              テスト名(全角３７文字以内)
            </template>
            <template v-slot:content>
              <v-row>
                <v-col cols="3">
                  <v-container fluid class="ma-0 pa-0">
                    <v-select-exam-title @changeTitle="changeTitle"/>
                  </v-container>
                </v-col>
                <!-- 注意書き -->
                <v-col cols="9">
                  <p style="color: red">テスト名を入力してください。（例）中学1年 英語 1学期中間テスト ⚫︎⚫︎中学校 1学期中間テスト 1年 英語。<br>他教科や他学年と統一されているかどうかもご確認ください。登録完了後の修正はできませんのでご注意ください。</p>
                </v-col>
              </v-row>

            </template>
          </v-section-panel>

          <!-- 実施日入力 -->
          <v-section-panel useBreak>
            <template v-slot:title>
              実施日
            </template>
            <template v-slot:content>
              <v-row>
                <v-col cols="3">
                  <v-container fluid class="ma-0 pa-0">
                    <v-menu
                      ref="implementationDateMenu"
                      v-model="implementationDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="implementationDateText"
                          label="実施日"
                          prepend-icon="mdi-calendar"
                          readonly
                          clearable
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="implementationDate"
                        no-title
                      />
                    </v-menu>
                  </v-container>
                </v-col>
              </v-row>
            </template>
          </v-section-panel>

        <v-preview-area :previewImages="previewImages" />

        <v-section-panel useBreak>
          <template v-slot:content>
            <v-btn color="secondary" @click.stop="pdfDownload" :disabled="!isTitled || ($store.state.sheet.title && $store.state.sheet.title.length) > 37">PDFダウンロード</v-btn>
          </template>
        </v-section-panel>

        <!-- 確定ボタン -->
        <v-btn color="gray" to="/teacher/score_setting">配点設定画面へ戻る</v-btn>
        <!-- 途中保存 -->
        <v-save-button
          :save-fnc="save"
        />
        <!-- プレビュー更新ボタン -->
        <v-btn
          class="ml-3"
          color="#4989d1"
          style="color: white;"
          @click="previewAllUpdate()"
        >
          プレビュー更新
        </v-btn>
        <v-btn class="ml-3" color="secondary" @click.stop="openRegistConfirmDialog" :disabled="!isPdfDownloaded">登録</v-btn>
      </template>
    </v-base-card>

    <!-- 登録ダイアログ -->
    <v-regist-dialog ref="regist"/>
    <!-- 登録確認ダイアログ -->
    <v-confirm-dialog
      ref="confirm"
      title="申込登録"
      message="問題確定で注文となりますが宜しいでしょうか（登録後，問題変更はできません）"
      buttonMessage="はい"
      cancelButtonMessage="いいえ"
      @confirm="regist"
    />

  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VResultTable from '@/components/molecules/ResultTable'
import VStepp from '@/components/molecules/Stepp'
import VBarCharts from '@/components/organizms/BarCharts'
import VSelectExamTitle from '@/components/molecules/SelectExamTitle'
import VRegistDialog from '@/components/molecules/RegistDialog'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import VPreviewArea from '@/components/molecules/PreviewArea'
import VChoiceGrades from '@/components/molecules/ChoiceGrades'
import VSaveButton from '@/components/molecules/SaveButton'
import config from "../../config"
import { getStepCols } from '../../plugins/responsive'

export default {
  components: {
    VBaseCard,
    VSectionPanel,
    VResultTable,
    VStepp,
    VBarCharts,
    VSelectExamTitle,
    VRegistDialog,
    VConfirmDialog,
    VPreviewArea,
    VChoiceGrades,
    VSaveButton
  },

  data: () => ({
    selectedGradeId: 1,
    stepps: [
      {no: 1, text: '問題差し替え', to: '/teacher/change', complete: true, editable: false},
      {no: 2, text: 'プレビュー', to: '/teacher/result', complete: true, editable: false},
      {no: 3, text: '配点設定', to: '/teacher/score_setting', complete: true, editable: false},
      {no: 4, text: 'テスト登録', to: '/teacher/regist_exam', complete: false, editable: false},
    ],
    stepCols: getStepCols(),
    implementationDateMenu: false,
    implementationDate: null
  }),

  computed: {
    previewImages() {
      const questionFilePaths = this.$store.state.sheet.questionImages
      const answerSheetFilePaths = this.$store.state.sheet.answerSheetImages
      const answerFilePaths = this.$store.state.sheet.answerImages
      const baseURL = this.$axios.defaults.baseURL

      return {
        question: {
          name: '問題',
          data: questionFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200} })
        },
        answerSheet: {
          name: '解答用紙',
          data: answerSheetFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200} })
        },
        answer: {
          name: '解答',
          data: answerFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200} })
        },
      }
    },
    isTitled() {
      return this.$store.state.sheet.title ? true : false
    },
    isPdfDownloaded() {
      return this.$store.state.sheet.pdfDlFlg ? true : false
    },
    implementationDateText: {
      get() {
        return this.formatDate(this.implementationDate)
      },
      set() {
        this.implementationDate = null
      }
    },
  },

  async mounted() {
    if(this.$store.state.sheet.requestCode.length > 0){
      this.$router.push('/teacher/home')
      return
    }

    if (this.$store.getters.selectedSubjectHasChild && !this.$store.getters['sheet/isPresetMode']) {
      const initialGradeId = [1, 2, 3].includes(parseInt(this.$store.state.user.uid.slice(2, 3)))
        ? parseInt(this.$store.state.user.uid.slice(2, 3))
        : 1
      // ログインアカウントが社会の場合は学年の初期値設定
      this.selectedGradeId = this.$store.state.sheet.sheetSearchCondition[0].grade_id || initialGradeId
    }

    const targetSheetId = this.$store.state.sheet.sheetContentPages.id
    const params = {
      sheet: {
        step: config.step.SHEET_NAMING,
      }
    }
    await this.$axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)

    this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
    await this.$store.dispatch('sheet/getSheetImages', { params: { type:'all' } })
    this.$app.$refs.loading.close({})
  },

  watch: {
    dialog(now) {
      if (!now) this.dialogImage = null;
    }
  },

  methods: {
    changeGrade(event) {
      this.selectedGradeId = event
    },
    openRegistConfirmDialog() {
      this.$refs.confirm.open()
    },
    async regist() {
      this.$app.$refs.loading.open({type: 'normal', message: '登録処理中です。'})

      //テスト名保存と申込登録処理
      const targetSheetId = this.$store.state.sheet.sheetContentPages.id

      // pdfParams作成
      await this.$store.dispatch('sheet/makeSendParams', {
        params:{type:'all', makeType:'preview', isSample:false, grade_id: this.selectedGradeId},
      })
      const pdfParams = this.$store.state.sheet.pdfParams

      // sheetUpdate用
      const params = {
        id: targetSheetId,
        sheet: {
          name: this.$store.state.sheet.title,
          implementation_date: this.implementationDate,
          step: config.step.COMPLETED,
        },
        pdf_params: pdfParams,
        // 社会でプリセット以外は最後学年を選択させる。
        grade_id: this.$store.getters.selectedSubjectHasChild && !this.$store.getters['sheet/isPresetMode']
                  ? this.selectedGradeId
                  : null
      }
      const res = await this.$axios.patch('/api/v1/teacher/sheets/' + targetSheetId+ '/complete', params)
      //表示用に発注番号をstoreに格納
      this.$store.commit('sheet/setRequestCode', {
        requestCode: res.data.code
      })
      //連続してテスト作成するとテスト名「オリジナル」を選択した際に、storeに残っていたtitleが表示されるのでリセットする
      this.$store.commit('sheet/setTitle', { title: '' })

      this.$app.$refs.loading.close()
      this.$refs.regist.open()
    },

    async previewAllUpdate() {
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー更新中'})
      // 強制的に更新するためにisUpdateをtrueにする
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})

      const targetSheetId = this.$store.state.sheet.sheetContentPages.id
      const params = {
        sheet: {
          step: config.step.SHEET_NAMING,
          name: this.$store.state.sheet.title,
        }
      }
      await this.$axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
      await this.$store.dispatch('sheet/getSheetImages', { params: { type:'all' } })
      this.$app.$refs.loading.close({})
    },

    async save() {
      let conditions = null
      //途中保存用パラメータ生成
      //タイトルタイプを保存
      //オリジナル作成で社会の場合、学年も検索条件に追加保存
      if(this.$store.getters['sheet/isPresetMode']) {
        conditions = {
          preset_id: this.$store.state.sheet.sheetSearchCondition.preset_id,
          subject_id: this.$store.state.sheet.sheetSearchCondition.subject_id,
          selected_max_point: this.$store.state.sheet.sheetSearchCondition.selected_max_point,
        }
      } else {
        conditions = this.$store.state.sheet.sheetSearchCondition.reduce((accumulator, condition) => {
          accumulator.push({
            grade_id: this.$store.getters.selectedSubjectHasChild ? this.selectedGradeId : condition.grade_id,
            subject_id: condition.subject_id,
            publisher_id: condition.publisher_id,
            page_ranges: condition.page_ranges,
            question_num: condition.question_num,
            difficulty_id: condition.difficulty_id,
            writing_question_flag: condition.writing_question_flag,
            listening_flag: condition.listening_flag,
            before_grade_flag: condition.before_grade_flag,
            selected_max_point_value: condition.selected_max_point_value,
            selected_max_point: condition.selected_max_point,
          })
          return accumulator
        }, [])
      }
      const params = {
        id: this.$store.state.sheet.sheetContentPages.id,
        sheet: {
          name: this.$store.state.sheet.title,
          search_conditions: conditions
        },
      }
      //途中保存処理
      await this.$store.dispatch('sheet/updateSheetStatus', params)
    },

    async pdfDownload(){
      this.$app.$refs.loading.open({type: 'print', message: 'ダウンロード処理中'})
      const isUpdate = this.$store.state.sheet.isUpdate.answerSheet
      if (isUpdate){
        const targetSheetId = this.$store.state.sheet.sheetContentPages.id
        const params = {
          id: targetSheetId,
          sheet: {
            name: this.$store.state.sheet.title,
          },
        }
        await this.$store.dispatch('sheet/updateSheetStatus', params)
      }
      const params = {
        type:'all',
        // 社会でプリセット以外は最後学年を選択させる。
        grade_id: this.$store.getters.selectedSubjectHasChild && !this.$store.getters['sheet/isPresetMode']
                  ? this.selectedGradeId
                  : null
      }

      await this.$store.dispatch('sheet/zipDownload', { params: params })
      this.$app.$refs.loading.close({})
      //PDFダウンロードフラグはリロード対応としてstoreで管理
      this.$store.commit('sheet/setPdfDlFlg', {
        pdfDlFlg: true
      })
    },

    changeTitle(){
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
    },

    setStepCols() {
      this.stepCols = getStepCols()
    },

    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
  }
}
</script>

<style lang="stylus" scoped>
.result-btn
  margin-right 10px

.result-score
  float right

.result-heading
  display inline-block

  &__text
    display inline-block

.pdf-button__message
  color: #f00;
  font-weight: bold;
  font-size: 13px;

</style>
